import styled from 'styled-components'

/** The grip's diameter, in screen pixels whatever the zoom. */
const GRIP_SIZE = 20

export const Wrapper = styled.div`
  position: absolute;
  /* Only the grip takes the pointer: everything else belongs to the entity under it */
  pointer-events: none;
`

/**
 * The seam between the two versions, kept neutral: it belongs to neither side,
 * and the Split action's own fill is what says which is which. The drawing is
 * left alone - tinting it would discolour the very thing being compared.
 */
export const Handle = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;

  background-color: ${({ theme }) => theme.colors.foreground.secondary.B};
  pointer-events: auto;
  cursor: ew-resize;

  /* Centred on the line rather than starting at it, so the grip sits on the seam */
  transform: translateX(-50%);

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: ${GRIP_SIZE}px;
    height: ${GRIP_SIZE}px;
    margin: ${-GRIP_SIZE / 2}px 0 0 ${-GRIP_SIZE / 2}px;

    border: 1px solid ${({ theme }) => theme.colors.foreground.secondary.B};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.background.secondary.A};
    box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
  }

  :focus-visible {
    outline: none;
  }

  &:focus-visible::after {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.sketch.A};
  }
`
